export var QuoteRequestStatus;
(function (QuoteRequestStatus) {
    QuoteRequestStatus["OPEN"] = "OPEN";
    QuoteRequestStatus["CLOSED"] = "CLOSED";
    QuoteRequestStatus["CANCELLED"] = "CANCELLED";
})(QuoteRequestStatus || (QuoteRequestStatus = {}));
export var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["PENDING"] = "PENDING";
    QuoteStatus["REVIEWED"] = "REVIEWED";
    QuoteStatus["APPROVED"] = "APPROVED";
    QuoteStatus["REJECTED"] = "REJECTED";
})(QuoteStatus || (QuoteStatus = {}));
//# sourceMappingURL=quote.js.map